import React from "react";
import { useTranslation } from "react-i18next";
import OwnerTeamPanel from "./OwnerTeamPanel";
import { useTeamDataStandalone } from "components/Team/userCard/UseTeamDataStandalone";


export default function OwnerTeamPanelWithData({ ownerId, ownerEmail, userAuth = true }) {
  const { t } = useTranslation();
  const team = useTeamDataStandalone({ ownerId, userAuth });

  const users = Array.isArray(team.inviteUser) ? team.inviteUser : [];
  const allCabines = users?.[0]?.cabines?.[0] || [];

  console.log(" OwnerTeamPanelWithData re-rendered - ownerId:", ownerId, "users.length:", users.length);

  if (team.isLoading) {
    return <div style={{ padding: "20px", textAlign: "center" }}> {t("common.loading")}</div>;
  }

  return (
    <OwnerTeamPanel
      ownerId={ownerId}
      ownerEmail={ownerEmail}
      userAuth={userAuth}
      isLoading={team.isLoading}
      users={users}
      allCabines={allCabines}
      displayRoleByUser={team.displayRoleByUser}
      selectDefaultValue={team.selectDefaultValue}
      numberCabsAuth={team.numberCabsAuth}
      maj={team.maj}
      setMaj={team.setMaj}
      majRole={team.majRole}
      setMajRole={team.setMajRole}
      setUpdateRole={team.setUpdateRole}
      setAllCabPermissions={team.setAllCabPermissions}
      setCabPermission={team.setCabPermission}
      refreshTeam={() => {
        team.setMaj((v) => !v);
        team.setMajRole((v) => !v);
      }}
    />
  );
}